<ng-template *ngIf="loading; then loadingTrue else loadingFalse"></ng-template>
<ng-template #loadingTrue>
  <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
</ng-template>
<ng-template #loadingFalse>
  <ng-template *ngIf="error; then isErrorTrue else isErrorFalse"></ng-template>
  <ng-template #isErrorTrue>
    <div class="d-flex flex-column justify-content-center align-items-center gap-3" style="height: 96px;">
      <div>{{error?.message}}</div>
      <button
        *ngIf="(sectionsState$ | async)?.licensesAdmin === true || (sectionsState$ | async)?.licensesEditor === true"
        class="mx-auto" mat-stroked-button color="primary" (click)="showLicenseAssignmentDialog()">
        Assegna Licenza
      </button>
    </div>
  </ng-template>
  <ng-template #isErrorFalse>
    <div class="row m-0 p-0">
      <div class="col-auto m-0 p-0">
        <div class="user-img-spacer"></div>
      </div>
      <div class="col m-0 p-0 ps-3">
        <div class="hstack m-0 p-0">
          <button
            *ngIf="(sectionsState$ | async)?.licensesAdmin === true || (sectionsState$ | async)?.licensesEditor === true"
            class="ms-auto" mat-stroked-button color="primary" (click)="showLicenseAssignmentDialog()">
            Assegna Licenza
          </button>
        </div>
        <div class="row m-0 mt-3 p-0" *ngFor="let licenseAssignment of licenseAssignmentsListing;">
          <div class="mb-3 border dea-radius p-3">
            <div class="d-flex flex-row gap-3">
              <div class="pt-2">
                <img src="{{licenseAssignment.license?.favicon}}" alt="{{licenseAssignment.license?.title}}" height="32"
                  width="32" />
              </div>
              <div class="d-flex flex-column gap-2 flex-grow-1 pt-2">
                <div class="fw-bold" style="font-size: 1.3rem;">{{licenseAssignment.license?.title}}</div>
                <div *ngIf="licenseAssignment.license?.key || licenseAssignment.key" class="d-flex flex-column gap-1">
                  <div *ngIf="licenseAssignment.license?.key" class="col m-0 p-0">Chiave Condivisa:
                    {{licenseAssignment.license?.key}}</div>
                  <div *ngIf="licenseAssignment.key && licenseAssignment.key != licenseAssignment.license?.key"
                    class="col m-0 p-0">Chiave Personale:
                    {{licenseAssignment.key}}</div>
                </div>
                <div class="d-flex flex-row gap-3">
                  <div class="col m-0 p-0">Inizio:
                    {{licenseAssignment.license?.start ? (licenseAssignment.license?.start | date:'yyyy-MM-dd') : ' -'}}
                  </div>
                  <div class="col m-0 p-0">Fine:
                    {{licenseAssignment.license?.end ? (licenseAssignment.license?.end | date:'yyyy-MM-dd') : ' -'}}
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-content-between">
                <div class="d-flex flex-row justify-content-end gap-2">
                  <button
                    *ngIf="(sectionsState$ | async)?.licensesAdmin === true || (sectionsState$ | async)?.licensesEditor === true"
                    class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Modifica Licenza"
                    title="Modifica" (click)="showLicenseAssignmentDialog(licenseAssignment.id)">
                    <mat-icon class="mb-1">edit</mat-icon>
                  </button>
                  <button
                    *ngIf="(sectionsState$ | async)?.licensesAdmin === true || (sectionsState$ | async)?.licensesEditor === true"
                    class="d-flex align-items-center dea-icon-btn" mat-icon-button
                    aria-label="Elimina Assegnazione Licenza" title="Elimina Assegnazione Licenza"
                    (click)="showDeleteDialog(licenseAssignment.id)">
                    <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;"
                      title="Elimina Assegnazione Licenza"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
